<template>
  <div>
    <div class="d-flex align-baseline ma-0 pa-0">
      <sf-sub-heading class="mt-2 mb-1 mr-1 ml-2">
        {{ name }}
      </sf-sub-heading>

      <sf-color-text
        v-if="products.length > showProductLimit"
        class="cursor-pointer"
        color="primary"
        @click="showLess = !showLess"
      >
        {{ showLess ? $t('more') : $t('less') }}
      </sf-color-text>
    </div>

    <div
      v-for="(product, index) in products.slice(0, showLess ? showProductLimit : products.length)"
      :key="product.productId"
      class="px-2 py-0"
    >
      <product-row
        v-if="$vuetify.display.mdAndUp"
        :product="product"
        show-add-to-cart
        :add-to-cart-event="ProductPageEvent.AddToCart.Accessory"
        :to="getProductLink(product.productId)"
        :loading-realtime-prices="false"
      />
      <div v-else class="mb-1">
        <product-card
          :product="product"
          :add-to-cart-event="ProductPageEvent.AddToCart.Accessory"
          :tabindex="index === 0 ? 0 : -1"
          show-product-identifiers
          small
          :is-focused="currentFocusIndex === index"
          @keydown="onKeyDown"
          @focus="onItemFocus(index)"
          @blur="onItemBlur(index)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfColorText from '@/components/text/SfColorText.vue'
import SfSubHeading from '@/components/text/SfSubHeading.vue'
import ProductCard from '@/modules/product/components/ProductCard.vue'
import ProductRow from '@/modules/product/components/ProductRow.vue'
import { getProductLink } from '@/modules/product/helpers'
import ProductPageEvent from '@/modules/tracking/events/productPage'
import { MediumProduct } from '@/types/index'
import { useArrowKeyGridNavigation } from '@/utils/useArrowKeyGridNavigation'
import { computed, PropType, ref } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  products: {
    type: Array as PropType<MediumProduct[]>,
    required: true
  }
})

const showLess = ref(true)
const showProductLimit = ref(2)
const numberOfProducts = computed(() => props.products.length)

const { currentFocusIndex, onItemFocus, onItemBlur, onKeyDown } = useArrowKeyGridNavigation(
  ref(1),
  numberOfProducts
)
</script>
